const fonts = {
  body: "Inter, sans-serif",
  heading: "Inter, serif",
  mono: "Menlo, monospace",
}

const fontWeights = {
  light: 200,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
}

const fontSizes = {
  "6xl": "66px",
  "5xl": "54px",
  "4xl": "44px",
  "3xl": "36px",
  "2xl": "30px",
  xl: "26px",
  lg: "22px",
  md: "18px",
  sm: "16px",
  xs: "12px",
}

const fontRanges = {
  "6xl": {
    fontSize: ["42px", null, null, "54px", null, "66px"],
  },
  "5xl": {
    fontSize: ["38px", null, null, "46px", null, "54px"],
  },
  "4xl": {
    fontSize: ["34px", null, null, "38px", null, "44px"],
  },
  "3xl": {
    fontSize: ["30px", null, null, "32px", null, "36px"],
  },
  "2xl": {
    fontSize: ["26px", null, null, "28px", null, "30px"],
  },
  xl: {
    fontSize: ["22px", null, null, "24px", null, "26px"],
  },
  lg: {
    fontSize: ["20px", null, null, "22px"],
  },
  md: {
    fontSize: ["16px", null, null, "18px"],
  },
  sm: {
    fontSize: ["14px", null, null, "16px"],
  },
  xs: {
    fontSize: ["12px", null, null, "14px"],
  },
}

export { fonts, fontWeights, fontSizes, fontRanges }
